import React from 'react';

// Components
import ArticleList from '../components/Article/ArticleList';

const Home = () => {
	return (
		<section className="home">
			<ArticleList />
		</section>
	);
};

export default Home;
